import { useTranslation } from "react-i18next";
import { Content } from "../../commons/Template/Template";
import {
  Table,
  TableBody,
  TableRow,
  TableRowHeader,
  TableRowItem,
  TableWrapper,
} from "../../commons/Table/Table";
import { formatAmount, formatDate } from "../../../format";
import { i18n } from "../../../i18n";
import { FormLoader } from "../../commons/Form/Form";
import { useTreasury } from "../Common/TreasuryContext";
import EmptySection from "../../commons/EmptySection/EmptySection";
import { List as ListIcon } from "@mui/icons-material";
import { useAlerts } from "../Common/AlertsContext";

export default function Alerts() {
  const { t } = useTranslation(["common", "treasury"]);
  document.title = t("treasury:alerts.title");

  const { alerts, loading: loadingAlerts } = useAlerts();
  const { accounts, loading: loadingTreasury } = useTreasury();

  const formatAmountFn = (amount, currency) =>
    amount ? formatAmount(amount, i18n.resolvedLanguage, currency) : "-";

  const alertsTable =
    !loadingAlerts &&
    !loadingTreasury &&
    alerts &&
    accounts &&
    alerts.map((alert) => ({
      thLabel: t("common:type"),
      thValue: t("treasury:alerts.categories." + alert.alert),
      items: [
        {
          label: t("common:label"),
          value: alert.wording,
        },
        {
          label: t("common:account"),
          value: accounts.find((account) => account.id === alert.account).name,
        },

        {
          label: t("common:amount"),
          value: formatAmountFn(
            alert.value,
            accounts.find((account) => account.id === alert.account).currency,
          ),
        },
        {
          label: t("common:date"),
          value: formatDate(alert.date, i18n.resolvedLanguage),
        },
      ],
    }));

  if (loadingAlerts || loadingTreasury) return <FormLoader />;
  return (
    <Content>
      {alerts.length === 0 ? (
        <div
          style={{
            padding: "1rem",
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
          }}
        >
          <EmptySection text={t("common:noData")} icon={<ListIcon />} />
        </div>
      ) : (
        <TableWrapper>
          <Table fixedLayout style={{ minWidth: "65rem" }}>
            <TableBody>
              {alertsTable.map((row, index) => (
                <TableRow key={index}>
                  <TableRowHeader thLabel={row.thLabel} thValue={row.thValue} />
                  {row.items.map((item, itemIndex) => (
                    <TableRowItem
                      key={itemIndex}
                      {...item}
                      title={item.value}
                    />
                  ))}
                </TableRow>
              ))}
            </TableBody>
          </Table>
        </TableWrapper>
      )}
    </Content>
  );
}
